import React, { useState, useEffect, useContext, useRef } from "react";
import * as yup from "yup";
import GiftIcon from "../../../styles/img/gift-icon.png";
import ShopIcon from "../../../styles/img/shop-icon.png";
import WalletIcon from "../../../styles/img/wallet-icon.png";
import CodeIcon from "../../../styles/img/code-icon.png";
import { useNavigate } from "react-router-dom";
import CloseWhiteIcon from "../../../styles/img/svg/CloseWhiteIcon";
import { UiInput } from "../../_uiMocks/components/form/UiInput";
import VoucherDetails from "../../pages/shop/views/VoucherDetails";
import { WishList } from "../../pages/common/WishList";
import UiTopSelectMobile from "../form/UiTopSelectMobile";
import { Form } from "react-final-form";
import UiTopInput from "../form/UiTopInput";
import {
    UiCol,
    UiSingleRow,
} from "../../_uiComponents/grid-container/GridContainer";
import { UiButtonPrimary } from "../../_uiComponents/form/UiButton";
import { useDispatch, useSelector } from "react-redux";
import {
    getRealTimeRewardCodeRequest,
    getRealTimeRewardReasonListRequest,
    getParticipantListRequest,
    smsRealTimeRewardCodeRequest,
    homeCampaignListRequest,
} from "../../../_redux/_actions";

import Validator from "../../../_helpers/validate.schema";
import { Context } from "../../../_context/Store";

export function UiBottomNavBar(props) {
    const [selected, setSelected] = useState(false);
    const [wallet, setWallet] = useState(false);
    const [favourite, setFavourite] = useState(false);
    const [code, setCode] = useState(false);

    let navigate = useNavigate();
    const actionDispatch = useDispatch();
    const [state, dispatch] = useContext(Context);

    const onGiftIconClick = () => {
        setSelected(true);
        setWallet(false);
        setFavourite(false);
        setCode(false);
    };
    const onCloseGiftSlide = () => {
        setSelected(false);
        setWallet(false);
        setFavourite(false);
        setCode(false);
    };

    const onCodeIconClick = () => {
        setSelected(false);
        setWallet(false);
        setFavourite(false);
        setCode(true);
    };

    const onShopIconClick = () => {
        // navigate("/app/shop/browse-products");
        setFavourite(true);
        setWallet(false);
        setSelected(false);
        setCode(false);
        dispatch({ type: "FAV_BOX_TOGGLE", payload: false });
    };
    const onWalletIconClick = () => {
        setWallet(true);
        setFavourite(false);
        setSelected(false);
        setCode(false);
        // navigate("/app/shop/voucher-wallet" );
    };

    const validateSchema = () =>
        yup.object().shape({
            recipient: yup.object().required("Recipient is required."),
            campaign: yup.object().required("Campaign is required."),
            reason: yup.object().required("Reason is required."),
            // code: yup.string().required("Code is required."),
        });

    const onValidate = async (values) => {
        return await Validator(values, validateSchema);
    };

    useEffect(() => {
        // actionDispatch(getRealTimeRewardReasonListRequest());
        // actionDispatch(getParticipantListRequest());
        // actionDispatch(homeCampaignListRequest());
    }, []);

    const { home } = useSelector((state) => {
        return {
            home: state.home,
        };
    });

    const generateCode = () => {
        actionDispatch(getRealTimeRewardCodeRequest());
    };

    const submit = async (values, form) => {
        actionDispatch(
            smsRealTimeRewardCodeRequest({
                userId: values.recipient.value,
                reasonId: values.reason.value,
                campaignId: values.campaign.value,
                rewardCode: home.code,
                form,
            }),
        );
    };
    const codeRef = useRef(null);
    const payBackRef = useRef(null);
    const favouriteRef = useRef(null);
    const walletrRef = useRef(null)

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
          document.removeEventListener("mousedown", handleOutsideClick);
        };
      });
    
      const handleOutsideClick = (e) => {
        if (payBackRef.current && !payBackRef.current.contains(e.target)) {
            setSelected(false);
        }
        if (codeRef.current && !codeRef.current.contains(e.target)) {
            setCode(false);
        }
        if (favouriteRef.current && !favouriteRef.current.contains(e.target)) {
            setFavourite(false);
            
        }
        if (walletrRef.current && !walletrRef.current.contains(e.target)) {
            setWallet(false);
            
        }
    }

      const handleCodeOutsideClick = (e) => {
     
    }
        
        // if (favouriteRef.current && !favouriteRef.current.contains(e.target)) {
        //     setSelected(false);
        //     setWallet(false);
        //     setFavourite(false);
        //     setCode(false);
        // }
        // if (walletrRef.current && !walletrRef.current.contains(e.target)) {
        //     setSelected(false);
        //     setWallet(false);
        //     setFavourite(false);
        //     setCode(false);
        // }
    //   };
    return (
        <>
            <div className="sb-mobile-bottom-nav-bar">
                {/* <UiBottomNavBarItem icon={GiftIcon} onClick={onGiftIconClick} /> */}
                {/* <UiBottomNavBarItem icon={CodeIcon} onClick={onCodeIconClick} /> */}
                <UiBottomNavBarItem icon={ShopIcon} onClick={onShopIconClick} />
                <UiBottomNavBarItem
                    icon={WalletIcon}
                    onClick={onWalletIconClick}
                />
            </div>
            <div
                className={
                    selected
                        ? "sb-mobile-gift-swipe-up gift-slide-up"
                        : " sb-mobile-gift-swipe-up gift-slide-down"
                }
                ref={payBackRef}
            >
                <span onClick={onCloseGiftSlide}>
                    <CloseWhiteIcon />
                </span>
                <div className="sb-mobile-gift-swipe-up__inner-content">
                    <h3>Payback</h3>

                   
                    <div className="sb-pay-back-coming-soon">
                    <h4>Coming Soon</h4>
                    <p>
                        You can payback anyone within your network with points
                        and you can add to your network via your profile
                    </p>
                    <UiInput placeholder="Enter members' email or handle here" />
                    <UiInput placeholder="Enter points total for gifting" />
                    <div className="sb-mobile-gift-now-btn">Pay Now</div>
                    </div>
                   
                </div>
            </div>

            <div
                className={
                    wallet
                        ? "sb-mobile-gift-swipe-up gift-slide-up"
                        : " sb-mobile-gift-swipe-up gift-slide-down"
                }
                ref={walletrRef}
                
            >
                <span onClick={onCloseGiftSlide}>
                    <CloseWhiteIcon />
                </span>
                <div className="sb-mobile-gift-swipe-up__inner-content">
                    <h3>Wallet</h3>
                    <span>Spend Now</span> 
                     <VoucherDetails />
                </div>
            </div>

            <div
                className={
                    favourite && state.ui_fav_box === false
                        ? "sb-mobile-gift-swipe-up gift-slide-up"
                        : " sb-mobile-gift-swipe-up gift-slide-down"
                }
                ref={favouriteRef}
               
            >
                <span onClick={onCloseGiftSlide}>
                    <CloseWhiteIcon />
                </span>
                <div className="sb-mobile-gift-swipe-up__inner-content">
                    <h3>Favourites</h3>
                    <p>Quick links to repeat your favourite purchases</p>
                    <WishList />
                </div>
            </div>

            <div
                className={
                    code
                        ? "sb-mobile-gift-swipe-up gift-slide-up"
                        : " sb-mobile-gift-swipe-up gift-slide-down"
                }
                ref={codeRef}
            >
                <span onClick={onCloseGiftSlide}>
                    <CloseWhiteIcon />
                </span>
                <div className="sb-mobile-gift-swipe-up__inner-content">
                    <h3>Realtime Reward Code Generator</h3>
                    <Form
                        mutators={{
                            setCodeValue: (args, state, utils) => {
                                utils.changeValue(
                                    state,
                                    "code",
                                    () => home.code,
                                );
                            },
                        }}
                        onSubmit={submit}
                        validate={onValidate}
                        render={({
                            form,
                            handleSubmit,
                            hasValidationErrors,
                        }) => {
                            return (
                                <form onSubmit={validateSchema}>
                                    <UiTopSelectMobile
                                        options={home.rewordRecipients.map(
                                            (rewordRecipient) => {
                                                return {
                                                    value: rewordRecipient.userId,
                                                    label: rewordRecipient.participantName,
                                                };
                                            },
                                        )}
                                        name="recipient"
                                        placeholder="Select option"
                                        label="Select reward recipient"
                                    />

                                    <UiTopSelectMobile
                                        options={home.campaignsList.map(
                                            (campaign) => {
                                                return {
                                                    value: campaign.campaignId,
                                                    label: campaign.campaignName,
                                                };
                                            },
                                        )}
                                        name="campaign"
                                        placeholder="Select option"
                                        label="Select campaign"
                                    />
                                    <UiTopSelectMobile
                                        options={home.reasonsForIssuance.map(
                                            (reasonForIssuance) => {
                                                return {
                                                    value: reasonForIssuance.id,
                                                    label: reasonForIssuance.reasonDescription,
                                                };
                                            },
                                        )}
                                        name="reason"
                                        placeholder="Select option"
                                        label="Select reason for issuance"
                                    />
                                    <UiSingleRow>
                                        <UiCol
                                            lg="6"
                                            className="col-6 mb-4 sb-bottom-nav-btn"
                                        >
                                            <UiButtonPrimary
                                                onClick={() => {
                                                    generateCode();
                                                }}
                                                btnName="Generate Code"
                                                size="70"
                                            />
                                        </UiCol>
                                        <UiCol
                                            lg="6"
                                            className="col-6 mb-4  btn-send-sms"
                                        >
                                            <UiButtonPrimary
                                                onClick={() => {
                                                    handleSubmit();
                                                }}
                                                btnName="Send as SMS"
                                                size="70"
                                                disabled={
                                                    hasValidationErrors ||
                                                    home.code == ""
                                                }
                                            />
                                        </UiCol>
                                    </UiSingleRow>
                                    <UiTopInput
                                        disabled
                                        name="code"
                                        label="6 Character code"
                                        placeholder="98432323"
                                        value={home.code}
                                    />
                                </form>
                            );
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export function UiBottomNavBarItem(props) {
    return (
        <>
            <div
                className="sb-mobile-bottom-nav-bar__section"
                onClick={props.onClick}
            >
                <div className="sb-mobile-bottom-nav-bar__icon">
                    <img src={props.icon} />
                </div>
            </div>
        </>
    );
}

// export function UiBottomNavBar(props) {

//     return (
//         <>
//             <div className='sb-mobile-bottom-nav-bar'>
//                 {props.children}
//             </div>

//         </>
//     )
// }

// export function UiBottomNavBarItem(props) {
//     const location = useLocation();

//     return (
//         <>

//             <div className='sb-mobile-bottom-nav-bar__section'>
//                 <div className='sb-mobile-bottom-nav-bar__icon'>
//                 <a href={'#' + props.hash}
//                      >
//                     <img src={props.navIcon} /> </a>
//                 </div>
//                 <div className='sb-mobile-bottom-nav-bar__title'>
//                     <a href={'#' + props.hash}
//                      className={location.hash == '#' + props.hash ? 'scroll-to-element-nav-active' : ''}>{props.navTitle}</a>
//                 </div>
//             </div>

//         </>
//     )
// }
